import React, { useRef } from 'react';
import uploadIcon from '../../assets/upload-icon.png';

const StepVideoIntro = ({ data, onChange, onSubmit, onBack, loading = false, error, success }) => {
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange('videoIntro', file);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 32, marginBottom: 8 }}>
        <svg width="79" height="51" viewBox="0 0 79 51" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M77.9696 4.82433C77.2826 4.47973 76.5956 4.47973 76.2522 4.82433L64.2304 14.1284V9.99324C64.2304 4.47973 59.7652 0 54.2696 0H9.96087C4.46522 0 0 4.47973 0 9.99324V41.0068C0 46.5203 4.46522 51 9.96087 51H54.2696C59.7652 51 64.2304 46.5203 64.2304 41.0068V36.8716L76.2522 46.1757C76.5956 46.5203 77.2826 46.5203 77.9696 46.1757C78.6565 45.8311 79 45.4865 79 44.7973V6.2027C79 5.51351 78.6565 5.16892 77.9696 4.82433Z" fill="#27B99A" />
        </svg>
      </div>
      <h2 style={{ margin: 0 }}>Video Intro</h2>

      <p style={{
        margin: 0,
        fontFamily: "'Poppins', sans-serif",
        fontSize: 14,
        color: '#333',
        lineHeight: '1.4',
        textAlign: 'left',
        maxWidth: '90%'
      }}>
        Upload a short intro to help clients feel comfortable and connected before their first session. Keep it simple and authentic.
      </p>

      <div
        style={{
          border: '1px solid #eee',
          borderRadius: 8,
          minHeight: 160,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#fafbfc',
          cursor: 'pointer',
        }}
        onClick={() => fileInputRef.current.click()}
      >
        {data.videoIntro ? (
          <video
            src={URL.createObjectURL(data.videoIntro)}
            controls
            style={{ width: 180, height: 120, objectFit: 'cover', borderRadius: 8 }}
          />
        ) : data.videoIntroUrl ? (
          <video
            src={data.videoIntroUrl}
            controls
            style={{ width: 180, height: 120, objectFit: 'cover', borderRadius: 8 }}
          />
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40 }}>
              <img alt="upload Logo" src={uploadIcon} />
            </div>
            <div style={{ color: '#1abc9c', fontWeight: 500 }}>Upload</div>
          </div>
        )}
        <input
          type="file"
          accept="video/*"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </div>
      <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
        <button
          type="button"
          onClick={() => onSubmit(data, () => { })}
          style={{
            marginTop: 32,
            padding: 0,
            background: 'none',
            border: 'none',
            cursor: loading || success ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            opacity: loading || success ? 0.6 : 1,
          }}
          disabled={loading || success}
        >
          <div style={{
            display: 'flex',
            alignItems: 'center',
            background: loading ? '#5a8c9e' : '#07405A',
            borderRadius: 8,
            boxShadow: '0px 4px 12px 0px rgba(7, 64, 90, 0.10)',
            padding: '0 24px 0 24px',
            height: 48,
            minWidth: 160,
            transition: 'background-color 0.2s ease',
            position: 'relative',
          }}>
            <span style={{
              color: '#fff',
              fontWeight: 700,
              fontSize: 16,
              fontFamily: 'inherit',
              marginRight: 24,
            }}>
              {loading ? 'Saving...' : 'Next'}
            </span>
            <span style={{ position: 'absolute', right: 10 }}>
              {loading ? (
                <div style={{
                  width: 20,
                  height: 20,
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  borderTop: '2px solid white',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}>
                  <style>
                    {`
                      @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                      }
                    `}
                  </style>
                </div>
              ) : (
                <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18.3673" cy="18.3673" r="17.8673" fill="white" fillOpacity="0.1" stroke="white" />
                  <path d="M17.993 11.995L24.7402 18.7421L17.993 24.7396" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path opacity="0.5" d="M13 13.7257L18.2478 18.8853L13 23.4716" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default StepVideoIntro;
